export default "__VITE_ASSET__NvAiJ43Y__"